import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { WhiteLabelLayout } from './components/layout/WhiteLabelLayout';
import { HomePage } from './pages/HomePage';
import { NetworkDetailPage } from './pages/NetworkDetailPage';
import { UserDetailPage } from './pages/UserDetailPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { WhiteLabelNetworkPage } from './pages/WhiteLabelNetworkPage';

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

// Import custom styles
import './css/theme.css';
import './css/animations.css';
import './css/App.css';
import './css/layout.css';
import './css/responsive.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="network/name/:name" element={<NetworkDetailPage />} />
          <Route path="network/code/:code" element={<NetworkDetailPage />} />
          <Route path="network/:id" element={<NetworkDetailPage />} />
          <Route path="n/:networkCode" element={<NetworkDetailPage />} />
          <Route path="n/:networkCode/person/:personCode" element={<UserDetailPage />} />
          <Route path="person/:personCode" element={<UserDetailPage />} />
          <Route path="network/:networkId/user/:userId" element={<UserDetailPage />} />
          <Route path="user/code/:code" element={<UserDetailPage />} />
          <Route path="user/:userId" element={<UserDetailPage />} />
          <Route path="product-detail/:networkId/:productId" element={<ProductDetailPage />} />
        </Route>

        <Route path="/:networkName" element={<WhiteLabelLayout />}>
          <Route index element={<WhiteLabelNetworkPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;